import { render } from "./SearchBarComponent.vue?vue&type=template&id=b8af7de2&scoped=true"
import script from "./SearchBarComponent.vue?vue&type=script&lang=js"
export * from "./SearchBarComponent.vue?vue&type=script&lang=js"

import "./SearchBarComponent.vue?vue&type=style&index=0&id=b8af7de2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8af7de2"]])

export default __exports__